/**
 * @generated SignedSource<<c0775297c5850347f107aad3e101a6e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_user" | "PdpSharedSellerTabsVariant_user" | "PdpSharedCallDealerCta_user" | "PdpSharedDealerDetailsHeader_user" | "PdpRespSellerItemTileCarousel_user">;
  readonly " $fragmentType": "PdpRespDealerDetails_user";
};
export type PdpRespDealerDetails_user$key = {
  readonly " $data"?: PdpRespDealerDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSellerItemTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5accae86aa28d40d2e180a07bba2dd26";

export default node;
